import { formattingNumber } from '../utils'
import { MONEY_FIELD } from '../type_name'
const invalidValue = [ undefined, null, '']
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'end'
    return header_clone
}
export default {
    name: MONEY_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        }
    },
    computed: {
        valueHandle() {
            if (invalidValue.includes(this.value) && !invalidValue.includes(this.header.default_value)) {
                return this.header.default_value
            }
            if (isNaN(this.value)) {
                return '-'
            }
            const _formattingNumber = this.header.formattingNumber || formattingNumber
            return _formattingNumber(this.value)
        }
    },
    render() {
        return <span>{this.valueHandle}</span> 
        
    }
}